import { render, staticRenderFns } from "./ThumbnailPreviewItem.vue?vue&type=template&id=2cf84267&scoped=true&"
import script from "./ThumbnailPreviewItem.vue?vue&type=script&lang=js&"
export * from "./ThumbnailPreviewItem.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailPreviewItem.vue?vue&type=style&index=0&id=2cf84267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf84267",
  null
  
)

export default component.exports